export enum Gender {
    Male = 'MALE',
    Female = 'FEMALE',
    Other = 'OTHER',
}

export type AddressDto = {
    street: string
    number: string
    postalCode: string
    locality: string
    country: string
}

export type PersonNameDto = {
    initials: string
    first: string
    given: string
    insertion: string
    last: string
}

export type PhoneNumberDto = {
    country: string
    subscriber: string
}
